import React, { Component } from "react";
import styled from "styled-components";
import JoinUsDialog from "./JoinUsDialog";

class JoinUsBubble extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false
    };
  }

  render() {
    let { openDialog } = this.state;

    return (
      <Wrapper>
        <Container onClick={() => this.setState({ openDialog: true })}>
          <img src="/images/pages/store/icon05.png" />
          <p>{"如果您也對咖啡充滿熱情，\n那就讓我們在好咖相遇吧！"}</p>
          <div className="tag">JOIN US</div>
          <div className="tail" />
        </Container>
        {openDialog && (
          <JoinUsDialog
            open={openDialog}
            onClose={() => this.setState({ openDialog: false })}
          />
        )}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  cursor: pointer;
  position: relative;
  padding: 10px;
`;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  position: relative;
  border-radius: 20px;
  margin: 0 auto;
  padding: 0px 45px;
  max-width: 900px;
  width: 100%;
  min-height: 100px;

  background: #bd9f84;
  box-shadow: 0 6px 30px -2px rgba(150, 150, 150, 0.5);

  & > img {
    margin-right: 19px;
    width: 100px;
    height: 100px;
  }

  & > p {
    font-family: inherit;
    margin: 16px 23px 16px 0px;
    letter-spacing: 1px;
    line-height: 30px;
    font-weight: 300;
    font-size: 18px;
    color: white;
  }

  & > .tag {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    max-width: 170px;
    width: 100%;
    min-height: 45px;
    border-radius: 2px;
    background: #ffffff;

    letter-spacing: 4px;
    font-size: 20px;
    color: #755b41;
  }

  & > .tag::before {
    content: "";
    background: #ffffff;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 22.5px 0 22.5px 20px;
    border-color: transparent transparent transparent #bd9f84;

    position: absolute;
    top: 0px;
    left: 0px;
  }

  & > .tag::after {
    content: "";
    background: #bd9f84;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 22.5px 0 22.5px 20px;
    border-color: transparent transparent transparent #ffffff;

    position: absolute;
    top: 0px;
    right: 0px;
  }

  & > .tail {
    position: absolute;
    bottom: -30px;
    right: 100px;

    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 40px 10px 0 50px;
    border-color: #bd9f84 transparent transparent transparent;
  }

  @media screen and (max-width: 550px) {
    flex-direction: column;
    justify-content: center;
    padding: 20px;

    & > img {
      margin: 0px;
    }

    & > p {
      margin: 12px;
      white-space: pre-wrap;
      text-align: center;
    }

    & > div {
      flex: 1;
    }
  }
`;

export default JoinUsBubble;
